// extracted by mini-css-extract-plugin
export default {"empty":"Skeleton-empty-MMk","shine":"Skeleton-shine-WJk"};